import React, { ReactNode } from 'react';
import { SimpleBlock, Text } from 'ui-builder';
import styles from './ExternalLinksList.module.scss';

export default function FubConnectionBlock(
  props: {
    content: ReactNode,
    actions: ReactNode,
    isHorizontal?: boolean,
  }
) {

  return (
    <SimpleBlock className={`${styles.block} ${props.isHorizontal ? styles.horizontal : ''}`}>
      <SimpleBlock className={styles.logoAndTitle}>
        <SimpleBlock className={styles.logo}>&nbsp;</SimpleBlock>
        <Text bold>Follow Up Boss</Text>
      </SimpleBlock>
      <SimpleBlock
        className={`${styles.contentAndActions} ${props.isHorizontal ? styles.horizontal : ''}`}>
        {props.content && (
          <SimpleBlock className={styles.content}>
            {props.content}
          </SimpleBlock>
        )}
        <SimpleBlock className={styles.actions}>
          {props.actions}
        </SimpleBlock>
      </SimpleBlock>
    </SimpleBlock>
  );

}
